import React, { useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";

const OrderSuccessModal = ({ open, onClose }) => {
    useEffect(() => {
        let timer;
        if (open) {
            timer = setTimeout(() => {
                onClose();
            }, 3000);
        }
        return () => clearTimeout(timer);
    }, [open, onClose]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="order-success-modal"
            aria-describedby="order-success-message"
            className="flex items-center justify-center p-4 backdrop-blur-sm"
        >
            <Box
                sx={{
                    bgcolor: "rgba(15, 23, 42, 0.95)", // Slate 900 with opacity
                    border: "1px solid rgba(139, 92, 246, 0.3)", // Violet border
                    borderRadius: "16px",
                    boxShadow: "0 0 40px rgba(139, 92, 246, 0.2)",
                    outline: "none",
                    maxWidth: "400px",
                    width: "100%",
                    textAlign: "center",
                    p: 4,
                    position: "relative",
                    overflow: "hidden",
                    // cursor: "none",
                }}
            >
                {/* Background Glow Effect */}
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-48 h-48 bg-purple-500/20 blur-[100px] rounded-full pointer-events-none" />

                <div className="relative z-10 flex flex-col items-center">
                    <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center mb-4 border border-green-500/20">
                        <CheckCircleOutline sx={{ fontSize: 40, color: "#4ade80" }} />
                    </div>
                    <Typography
                        id="order-success-modal"
                        variant="h5"
                        component="h2"
                        sx={{
                            fontWeight: "bold",
                            background: "linear-gradient(to right, #c084fc, #f472b6)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            mb: 1,
                        }}
                    >
                        Payment Completed!
                    </Typography>

                    {/* <Typography
                        variant="h6"
                        sx={{ color: "white", fontSize: "1.1rem", mb: 2, fontWeight: 500 }}
                    >
                        Order Created Successfully
                    </Typography> */}

                    <Typography
                        id="order-success-message"
                        sx={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.95rem", mb: 3, lineHeight: 1.5 }}
                    >
                        Thank you for purchase. A download link has been sent to your email address.
                    </Typography>

                    <div className="w-full h-1 bg-white/10 rounded-full overflow-hidden mt-2">
                        <div className="h-full bg-gradient-to-r from-purple-500 to-pink-500" style={{ animation: "progress 3s linear forwards" }} />
                    </div>
                </div>

                <style>
                    {`
            @keyframes progress {
                0% { width: 100%; }
                100% { width: 0%; }
            }
            `}
                </style>
            </Box>
        </Modal>
    );
};

export default OrderSuccessModal;
